import { useState } from "react";
import { X } from "lucide-react";
import { useSubmitScript, type BloggerPlacement } from "@/shared/api/wb";

/** Native-only: the blogger submits a script/сценарий draft for the
 * advertiser to approve BEFORE anything publishes — see submit_script() in
 * blogger_portal.py. Seeding never shows this (accept() skips straight to
 * 'scheduled', no draft step). */
export function ScriptModal({ bloggerId, placement, onClose }: {
  bloggerId: string; placement: BloggerPlacement; onClose: () => void;
}) {
  const [draft, setDraft] = useState(placement.script_draft ?? "");
  const submit = useSubmitScript();

  function onSubmit() {
    if (!draft.trim()) return;
    submit.mutate({ bloggerId, placementId: placement.id, scriptDraft: draft.trim() }, { onSuccess: onClose });
  }

  return (
    <div className="fixed inset-0 z-[120] grid place-items-center" style={{ background: "rgba(28,28,28,0.55)", backdropFilter: "blur(6px)" }} onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()} className="bg-white rounded-lg shadow-lg fade-up p-6 grid gap-4" style={{ width: "min(520px, 92vw)" }}>
        <div className="flex items-start justify-between">
          <div>
            <div className="text-[11px] font-display font-semibold uppercase tracking-[0.16em] text-ink-40 mb-1">Сценарий на согласование</div>
            <h3 className="font-display font-extrabold text-[19px] tracking-tight">{placement.campaign_product}</h3>
          </div>
          <button onClick={onClose} className="w-8 h-8 grid place-items-center rounded-md text-ink-60 hover:bg-ink-6"><X size={16} /></button>
        </div>
        <p className="text-[12.5px] text-ink-40 -mt-2">
          Опишите план ролика/поста — рекламодатель одобрит его до публикации или пришлёт правки.
        </p>
        <textarea
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          placeholder="Хронометраж, ключевые тезисы, формат подачи…"
          rows={6}
          autoFocus
          className="w-full px-3 py-2.5 rounded-md border border-ink-12 text-[13.5px] outline-none focus:border-ink resize-none"
        />
        <div className="flex gap-2 justify-end">
          <button onClick={onClose} className="h-9 px-4 rounded-pill border border-ink-12 text-[13px] font-display font-semibold text-ink-60 hover:border-ink/40">Отмена</button>
          <button onClick={onSubmit} disabled={submit.isPending || !draft.trim()}
            className="h-9 px-4 rounded-pill bg-lime text-[var(--fg-on-accent)] text-[13px] font-display font-semibold hover:[background:color-mix(in_srgb,var(--wb-lime)_88%,black)] disabled:opacity-50">
            {submit.isPending ? "Отправляем…" : "Отправить на согласование"}
          </button>
        </div>
      </div>
    </div>
  );
}
